'use client';

import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useResponsive } from '@/hooks/useResponsive';

interface BackToTopButtonProps {
  className?: string;
  showAfter?: number; // píxeles de scroll
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({ className = '', showAfter = 320 }) => {
  const { isMobile } = useResponsive();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop;
      setIsVisible(y > showAfter);
    };

    // Ejecutar una vez por si ya hay scroll
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showAfter]);

  if (isMobile) return null;

  const handleClick = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      window.scrollTo(0, 0);
    }
  };

  return (
    <button data-component-id="src/components/common/BackToTopButton.tsx:39:4" data-component-path="src/components/common/BackToTopButton.tsx" data-component-line="39" data-component-file="BackToTopButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
      type="button"
      aria-label="Volver arriba"
      onClick={handleClick}
      className={
        `fixed right-6 bottom-6 z-50 rounded-full shadow-lg transition-all duration-300 
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3D1C1A]/30 
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'} 
        bg-global-1 text-global-4 hover:opacity-90 w-12 h-12 flex items-center justify-center ${className}`
      }
    >
      <FaArrowUp data-component-id="src/components/common/BackToTopButton.tsx:50:6" data-component-path="src/components/common/BackToTopButton.tsx" data-component-line="50" data-component-file="BackToTopButton.tsx" data-component-name="FaArrowUp" data-component-content="%7B%22elementName%22%3A%22FaArrowUp%22%2C%22className%22%3A%22w-5%20h-5%22%7D" className="w-5 h-5" />
    </button>
  );
};

export default BackToTopButton;


